import { render, staticRenderFns } from "./st-kpi-card.vue?vue&type=template&id=6ea36ef8&scoped=true"
import script from "./st-kpi-card.vue?vue&type=script&lang=js"
export * from "./st-kpi-card.vue?vue&type=script&lang=js"
import style0 from "./st-kpi-card.vue?vue&type=style&index=0&id=6ea36ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea36ef8",
  null
  
)

export default component.exports